/** @file Archivo con las conexiones a la API del módulo de Sumaleasing */
import axios, { AxiosResponse } from "axios";
import { ApiRoutes } from "../enum/Api.enum"
import { Contract, ContractEntry, ContractFilters } from "../interfaces/Contracts.interface";
import utils from "../../../auth/data/utils";
import { ErpApiContractView, ErpApiGetContractsResponse, ErpApiGetExcelResponse } from "../interfaces/Api.interface";
import { User } from "../../../interfaces/User.interface";

// Agregar un abort controller
export const getContracts = async(userInfo: User, contractFilters: ContractFilters, limit: number, offset:number): Promise<[number, ContractEntry[]]> => {
    const API_BASE_URL = `${utils().protocol + userInfo.host}/`;
    const start_date = contractFilters.start_date.toISOString().split("T")[0];
    const end_date = contractFilters.end_date.toISOString().split("T")[0];
    let total = 0;
    let url = `${API_BASE_URL}${ApiRoutes.GetContracts}${userInfo.cid}?date_from=${start_date}&date_to=${end_date}&status=${contractFilters.status}`;

    if(contractFilters.from_start === "start_date")
    {
        url += "&range_by_start_date=1"
    }
    else
    {
        url += "&range_by_start_date=0"
    }

    if(contractFilters.contract_no.length > 0)
    {
        url += "&contract_no=" + contractFilters.contract_no.trim()
    }

    if(contractFilters.username.length > 0)
    {   
        url += "&username=" + contractFilters.username.trim()
    }

    url += `&limit=${limit}&skip=${offset}`;

    let res:AxiosResponse<ErpApiGetContractsResponse>|null = null;
    let contracts: ContractEntry[] = [];

    try
    {
        res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`,
            },
        });

        if(res)
        {
            res.data.contracts.forEach((contract: ContractEntry) => {
                contracts.push(contract);
            })
            total = res.data.total;
        }
    }
    catch(error)
    {
        console.error(error);
    }

    return [total, contracts];
}

export const getContractsExcel = async(userInfo: User, contractFilters: ContractFilters): Promise<string> => {
    const API_BASE_URL = `${utils().protocol + userInfo.host}/`;
    const start_date = contractFilters.start_date.toISOString().split("T")[0];
    const end_date = contractFilters.end_date.toISOString().split("T")[0];
    let url = `${API_BASE_URL}${ApiRoutes.GetContractsExcel}${userInfo.cid}?date_from=${start_date}&date_to=${end_date}&status=${contractFilters.status}`;

    if(contractFilters.from_start === "start_date")
    {
        url += "&range_by_start_date=1"
    }
    else
    {
        url += "&range_by_start_date=0"
    }

    if(contractFilters.contract_no.length > 0)
    {
        url += "&contract_no=" + contractFilters.contract_no.trim()
    }

    if(contractFilters.username.length > 0)
    {   
        url += "&username=" + contractFilters.username.trim()
    }

    let res:AxiosResponse<ErpApiGetExcelResponse>|null = null;
    let report: string = "";

    try
    {
        res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`,
            },
        });

        if(res)
        {
            report = res.data.report;
        }
    }
    catch(error)
    {
        console.error(error);
    }

    return report;
}

export const getContract = async(userInfo: User, contractID: string): Promise<Contract|null> => {
    const API_BASE_URL = `${utils().protocol + userInfo.host}/`;
    let url = `${API_BASE_URL}${ApiRoutes.ViewContract}${contractID}?customer_id=${userInfo.cid}`;
    let contract = null
    let res:AxiosResponse<ErpApiContractView>|null = null;

    try
    {
        res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`,
            },
        });

        if(res && res.data.result)
        {
            contract = res.data.contract;
        }
    }
    catch(error)
    {
        console.error(error);
    }

    return contract;
}